import { render } from "./valForm.vue?vue&type=template&id=2d588d88&ts=true"
import script from "./valForm.vue?vue&type=script&lang=ts"
export * from "./valForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__